<template>
  <div class="about">

    <section class="about-head">
      <b-row>
        <b-col md="5" class="order-md-last">
          <img class="about-photo" src="../assets/img/me.png" alt="">
        </b-col>
        <b-col md="7">
          <h1>
            Hello, I'm Ronnel Sanchez.
          </h1>
          <p>I am a UI/UX Designer and Front-End Developer. I have 6 years of UI/UX design experience and specialize in user-centered design, information architecture and prototyping.</p>
          <p>Having design and programing skill sets, I'm keen to connect People and Technology.</p>
          <br>
          <a href="/static/files/Ronnel_Sanchez-CV.pdf" class="btn btn-primary btn-lg btn-download" target="_blank">
            Download Resume
          </a>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Experiences</h3>
          <b-row>
            <div class="col-md-3">
              <small class="mb-3 content-date"><i>Nov 2017 - Present</i></small>
            </div>
            <div class="col-md-9">
              <div class="content-title">UI/UX Designer and Front-End Developer</div>
              <div class="content-subtitle">Ducatus Global Singapore - Philippine Based</div>
              <div class="content-body">
                <p>Key designer for Ducatus Customer console site redesign.	Create user flow, wireframes, personas, storyboards, process flow, interaction design and information architecture.</p>
              </div>
            </div>
          </b-row>
          <b-row>
            <div class="col-md-3">
              <small class="mb-3 content-date"><i>Dec 2012 - Nov 2017</i></small>
            </div>
            <div class="col-md-9">
              <div class="content-title">UI/UX Designer and Developer</div>
              <div class="content-subtitle">Trend Micro - Philippines</div>
              <div class="content-body">
                <p>Deliver UI/UX design for internal and external Trendmicro user. Co-lead the Web development team from analysing business requirements, user research and conceptualizing information architecture.</p>
              </div>
            </div>
          </b-row>
          <b-row>
            <div class="col-md-3">
              <small class="mb-3 content-date"><i>Sept 2012 - Oct 2012</i></small>
            </div>
            <div class="col-md-9">
              <div class="content-title">Graphical User Interface Designer</div>
              <div class="content-subtitle">Job and Esther Technologies - Philippines</div>
              <div class="content-body">
                <p>Create graphical user interfaces (GUIs) for a variety of software products like mobile app, websit, desktop software, games app and enterprise applications.</p>
              </div>
            </div>
          </b-row>
          <b-row>
            <div class="col-md-3">
              <small class="mb-3 content-date"><i>Dec 2010 - Sept 2012</i></small>
            </div>
            <div class="col-md-9">
              <div class="content-title">UI Developer</div>
              <div class="content-subtitle">Coding Solution Information Technology - Philippines</div>
              <div class="content-body">
                <p>Key designer for CSIT projects: Web App, Window based applications and Saas.</p>
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Awards</h3>
          <b-row>
            <b-col>
              <div class="content-title">Special Award - "Bravery" 2017</div>
              <div class="content-subtitle">Trend Micro Philippines</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="content-title">Employee of the Quarter (2H 2016)</div>
              <div class="content-subtitle">Trend Micro Philippines</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="content-title">Employee of the Quarter (1H 2015)</div>
              <div class="content-subtitle">Trend Micro Philippines</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Education</h3>
          <b-row>
            <div class="col-md-3">
              <small class="content-date"><i>2008 - 2012</i></small>
            </div>
            <div class="col-md-9">
              <div class="content-title">Bachelor of Science in Information Technology</div>
              <div class="content-subtitle">AMA Computer University - Santa Cruz Laguna, Philippines</div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col md="7">
          <h3>Skills</h3>
          <ul class="list list-unstyled">
            <li>UI/UX Design</li>
            <li>Wireframing</li>
            <li>Prototyping</li>
            <li>Front-End Development</li>
            <li>Visual Design</li>
            <li>Graphic Design</li>
            <li>Agile Methodology</li>
          </ul>
        </b-col>
      </b-row>
    </section>

  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>



// WEBPACK FOOTER //
// src/views/About.vue